import {FC, ReactNode} from 'react'

import {TextFontWeight} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {Currency} from '@/utils/currency'

import {FormSummaryItemWithButton} from './FormSummaryItemWithButton'
import {FormSummaryItemWithPrice} from './FormSummaryItemWithPrice'

type FormSummaryItemProps = {
  title: string | ReactNode
  description?: string | ReactNode
  price?: number
  button?: ReactNode
  tooltip?: ReactNode
  fontWeight?: TextFontWeight
  textColor?: string
  isLowercase?: boolean
  hasDecimal?: boolean
  currency?: Currency
  onRemove?: () => void
  isPriceHighlighted?: boolean
}

export const FormSummaryItem: FC<React.PropsWithChildren<FormSummaryItemProps>> = ({
  title,
  description,
  price,
  button,
  tooltip,
  fontWeight,
  textColor,
  isLowercase,
  hasDecimal,
  currency,
  onRemove,
  isPriceHighlighted,
}) => (
  <>
    <div className="wrapper" data-test="ForsmSummeryItem-item">
      {button ? (
        <FormSummaryItemWithButton
          title={title}
          button={button}
          fontWeight={fontWeight}
          textColor={textColor}
          isLowercase={isLowercase}
        />
      ) : (
        <FormSummaryItemWithPrice
          title={title}
          description={description}
          price={price}
          tooltip={tooltip}
          fontWeight={fontWeight}
          textColor={textColor}
          isLowercase={isLowercase}
          hasDecimal={hasDecimal}
          currency={currency}
          onRemove={onRemove}
          isPriceHighlighted={isPriceHighlighted}
        />
      )}
    </div>

    <style jsx>{`
      .wrapper + .wrapper {
        margin-top: ${theme.spacing[3]};
      }
    `}</style>
  </>
)
